import { mean } from 'lodash';
import { GeoPoint } from '../../location/types';

export function convertPointsToCoordinates(points: GeoPoint[]) {
    return points.map((point) => [point.longitude, point.latitude]);
}

export function getPolygonCenter(points: GeoPoint[]) {
    const meanLatitude = mean(points.map((point) => point.latitude));
    const meanLongitude = mean(points.map((point) => point.longitude));
    return { latitude: meanLatitude, longitude: meanLongitude };
}
